import React from 'react';
import TechApproval from '../../../components/techmng/support/TechApproval';

const TechApprovalContainer = ({approvalList}) => {
  return <TechApproval approvalList={approvalList}/>
};

export default TechApprovalContainer;
